let commentTimer;
var comment = {
	w: 0,
	m: 12,
	count: 0,
	len: 0,
	duration: 8000,
	arry: [],
	xs: [],
	init: function(){
		comment.len = $(".comments_inner ul li").length;
		comment.w 	= $(".comments_inner ul li").width();
		comment.arry = [];
		comment.xs = [];
		$(".comments_inner ul li").each(function(i){
			comment.arry.push(i);
			comment.xs.push( (comment.w + comment.m)*i )
		});
		comment.resize();
		comment.setDelay();
		$(document).off("keyup").on("keyup", function(e){
			let k = e.keyCode;
			if(k === 37){
				comment.inc();
			}
		});
		commentTimer = setInterval(function(){
			if(!isSmallScreen){
				comment.inc();
			}
		}, comment.duration);
	},
	resize: function(){
		comment.w = $(".comments_inner ul li").width();
		comment.xs = [];
		$(".comments_inner ul li").each(function(i){
			comment.xs.push( (comment.w + comment.m)*i )
		});
		if(isSmallScreen){
			for(var i = 0; i < comment.len; i++){
				let _left = comment.xs[ i ];
				$(".comments_inner ul li").eq(comment.arry[i]).css({
					"transform": ""
				});
			}
		}else{
			for(var i = 0; i < comment.len; i++){
				let _left = comment.xs[ i ];
				$(".comments_inner ul li").eq(comment.arry[i]).css({
					"transform": "translate3d(" + _left + "px,0,0)"
				});
			}
		}

	},
	inc: function(){
		comment.count++;
		comment.change();
	},
	change: function(){
		if(isSmallScreen){ return false;}

		let _left = (comment.w + comment.m);
		for(var i = 0; i < comment.len; i++){
			$(".comments_inner ul li").eq(comment.arry[i]).css({
				"transform": "translate3d(" + (comment.xs[ i ] - _left) + "px,0,0)"
			});
		}
		setTimeout(function(){
			comment.arry.push(comment.arry[0]);
			comment.arry.shift();
			
			$(".comments_inner").addClass("notransition");
			$(".comments_inner ul li").css("transition-delay", "");
			
			setTimeout(function(){
				for(var i = 0; i < comment.len; i++){
					let _left = comment.xs[ i ];
					$(".comments_inner ul li").eq(comment.arry[i]).css({
						"transform": "translate3d(" + _left + "px,0,0)"
					});
				}
				comment.setDelay();
				setTimeout(function(){
					$(".comments_inner").removeClass("notransition");
				},100);
			}, 100);

		}, 1200);
	},
	setDelay: function(){
		for(var i = 0; i < comment.len; i++){
			$(".comments_inner ul li").eq( comment.arry[i] ).css({
				"transition-delay": (i*.05) + "s"
			});
		}
	}
}